import React from 'react';
import { useParams } from 'react-router-dom';

import States from './States';

const StatesModalRoute: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const mode = id ? 'edit' : 'create';

  return (
    <States initialModal={{ mode, stateId: id }} modalReturnTo="/states" />
  );
};

export default StatesModalRoute;
